// 积分枚举
export const POINT_TYPE_ENUM = {
  CLAIM_NOW: 0, // 立即领取
  CLAIMED: 1, // 已领取
  USE_NOW: 2, // 立即使用
  SOLD_OUT: 3 // 已抢完
}

export const REDPACKET_TYPE_ENUM = {
  POINTS: 3 // 积分
}

// 积分类型红包图片映射关系
export const REPORT_IMAGE_MAP = {
  [POINT_TYPE_ENUM.CLAIM_NOW]: 0, // 立即领取
  [POINT_TYPE_ENUM.CLAIMED]: 4, // 已领取
  [POINT_TYPE_ENUM.USE_NOW]: 1, // 立即使用
  [POINT_TYPE_ENUM.SOLD_OUT]: 2 // 已抢完
}
